<template>
  <div class="TermBankBox">
    <div class="topBox">
      <button class="themeGoBut" @click="getMesBox" v-if="!setup">上传</button>
      <i style=" cursor: pointer" class="search el-icon-search"></i>
      <input type="text" v-model="search_mod" placeholder="搜索术语库名" />
    </div>
    <el-table class="tab" tooltip-effect="dark" style="width:100%"
      :data="list.filter(data => !search_mod || data.name.toLowerCase().includes(search_mod.toLowerCase()))">
      <el-table-column align="center" type="index" label="序号" width="80" prop="createTime"></el-table-column>
      <el-table-column align="center" label="术语库名" width prop="name" sortable></el-table-column>
      <el-table-column align="center" label="语言对" width="" prop="langDesc"></el-table-column>
      <el-table-column align="center" label="领域" width="" prop="domainName"></el-table-column>
      <el-table-column align="center" label="数量" width="" prop="sentCount"></el-table-column>
      <el-table-column align="center" label="启用" prop="isEnable" width="">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isEnable" active-color="#29c0d5" inactive-color="#fff">
          </el-switch>
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-switch class="switchOff" v-model="switchValue" active-color="#13ce66" inactive-color="#ff4949"
      @change="switchChange">
    </el-switch> -->
    <el-checkbox v-if="TermBankList.length>0" class="switchOff" :indeterminate="isIndeterminate" v-model="switchValue"
      @change="switchChange">全选</el-checkbox>
    <messageBox :isShow="mesBox" v-if="mesBox" tit="上传术语库" txt mesShow="1" :imgSrc="imgSrc1" projectId="371" ifForm="0"
      @message="empty" @messageIf="messageIf"></messageBox>
  </div>
</template>

<script>

export default {
  props: [
    "TermBankList",
    "setup",
    "domain",
    "domainCode"
  ],
  data () {
    return {
      list: this.TermBankList,
      switchValue: "",
      loading: true,
      search_mod: "",
      imgSrc1: require("../../../assets/imgs/memory/popup_background.png"), // 弹窗title背景图
      mesBox: false,
      queryData: "",
      isIndeterminate: true,
      termTimeOut: ""
    };
  },
  created () {

  },
  mounted () {
    this.queryData = JSON.parse(this.$Base64.decode(this.$route.query.key));
    this.getTermBankList();
  },
  watch: {
    list: {
      handler (newName, oldName) {  // 监听表格switch 并改变总开关
        this.switchValue = this.listEach(newName);
        // 监测状态

      },
      // 开启深度监听
      deep: true
    }
  },
  beforeDestroy () {
    clearInterval(this.termTimeOut);
  },
  methods: {
    listEach (data) {
      let off = true;
      let on = true;
      data.forEach((item) => {
        if (!item.isEnable) {
          off = false
        } else {
          on = false;
        }
      })
      if (!on && !off) {
        this.isIndeterminate = true;
        return false
      } else {
        this.isIndeterminate = false;
      }
      return off
    },
    // 获取术语库列表
    getTermBankList () {
      this.switchValue = this.listEach(this.TermBankList) // 如果全部为true 则总开关为true
      this.loading = false;
    },
    // 总开关
    switchChange (data) {
      this.list.filter(data => !this.search_mod || data.name.toLowerCase().includes(this.search_mod.toLowerCase())).forEach(item => {
        item.isEnable = data
      })
      // this.$set(this.TermBankList)
    },
    // 上传
    getMesBox () {
      if (this.mesBox) {
        this.mesBox = false;
      } else {
        this.mesBox = true;
      }
    },
    // 取消弹窗
    messageIf () {
      var that = this;
      that.mesBox = false;
    },
    // 弹窗确定事件
    empty (data) {
      console.log(this.$store.state.newForm.sentFileUrlList);
      var reg = /([^\.\/\\]+)\.([a-z]+)$/i; // 匹配拿到文件名
      var that = this;
      let params = {};
      if (data.length === 0) {
        that.$message.closeAll()
        that.$message({
          message: "请上传文件",
          type: "warning"
        });
        return;
      }
      that.mesBox = false;
      let termUrlList = this.$store.state.newForm.sentFileUrlList;
      if (termUrlList.length) {
        params = {
          projectId: that.queryData.projectId,
          sentFileUrlList: termUrlList,
          name: reg.exec(data[0].name)[1],
          domainCode: that.domainCode,
          domainName: that.domain,
          sourceLang: that.queryData.sourceLang,
          targetLang: that.queryData.targetLang,
          langDesc: that.queryData.langDesc,
        };
        this.catReq1Service("/api/v1/term/addTransTermLib", params)
          .then(function (response) {
            if (!response.success) {
              return;
            }
            response.result.isEnable = true;
            that.TermBankList.push(response.result)
          });
      }
    },
  }
};
</script>
<style lang="less" scoped>
.TermBankBox {
  height: calc(100% - 260px);
  .tab {
    top: -20px;
    max-height: 100%;
    overflow-y: auto;
  }
  .el-table::before {
    height: 0;
  }
  /deep/.el-table th.is-leaf {
    border-bottom: 0px !important;
  }
  /deep/.el-table {
    .cell {
      // overflow: visible;
    }
    td {
      border-bottom: 0px !important;
    }
  }
  .switchOff {
    float: right;
    margin-right: 80px;
  }
  // 搜索框开始
  .topBox {
    line-height: 38px;
    position: relative;
    top: -30px;
    input {
      float: right;
      width: 224px;
      height: 36px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(184, 196, 206, 1);
      border-radius: 2px 0px 0px 2px;
      padding: 0 10px;
      padding-right: 24px;
    }
    input:focus {
      outline: none;
      border: 1px solid #454545;
    }
    button {
      float: right;
      margin-right: 20px;
    }
    .search {
      position: relative;
      float: right;
      right: 30px;
      line-height: 36px;
    }
  }
  // 搜索框结束
}

</style>